module.exports = __webpack_public_path__ + "media/images/pin-blue-ce37fbeb5e72167d4ecc9f6cade07755.png";